import { Box, CircularProgress } from '@mui/material'
import { useRouter } from 'next/router'
import { signOut, useSession } from 'next-auth/react'
import { ReactNode, useEffect } from 'react'

const PUBLIC_PATHS = new Set(['/sign-in'])

export const SessionErrorHandler = ({ children }: { children?: ReactNode }) => {
  const { data: session, status } = useSession()
  const router = useRouter()
  const isPublicPage = PUBLIC_PATHS.has(router.pathname)
  const hasSessionError = session?.error === 'RefreshAccessTokenError'

  useEffect(() => {
    if (isPublicPage) return

    if (hasSessionError) {
      void signOut({ callbackUrl: '/sign-in' })
      return
    }

    if (status === 'unauthenticated') {
      void router.replace('/sign-in')
    }
  }, [hasSessionError, isPublicPage, router, status])

  if (isPublicPage) return <>{children}</>

  if (hasSessionError || status === 'unauthenticated') return null

  if (status === 'loading') {
    return (
      <Box sx={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    )
  }

  return <>{children}</>
}
